import { Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import NotFoundPage from './pages/Error';
import GlobalStyle from "./styles/global";
import { NossaSolucao } from './components/layout/middle/nossaSolucao';
import WhatsAppPopup from './components/PopUp';
import { ToastProvider } from './hooks/toast';
import AppProvider from './hooks';
import { LandingPage } from './pages/LandingPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/midiaembh" element={<LandingPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/nossasolucao" element={<NossaSolucao />} />
        </Routes>
        <WhatsAppPopup />
        <GlobalStyle />
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
